import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import {   useFormik } from "formik";
import { useFormikContext } from "formik";

import { format } from "date-fns";
import { fr } from "date-fns/locale";


//import {   Field, FieldArray, ErrorMessage } from "formik";
//import {  Form, Field, FieldArray, ErrorMessage } from "formik";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";


//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getInvoices as onGetInvoices,
   

} from "store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import ShowInvoiceModal from "./ShowInvoiceModal";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    //Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";




const Invoice = () => {

    //meta title
    document.title = "Factures | YETA TV";

    const [modal, setModal] = useState(false);
    const [modal1, setModal1] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);


 

    const dispatch = useDispatch();

    
    const InvoiceProperties = createSelector(
        (state) => state.invoiceReducer, 
        (invoiceReducer) => ({
            invoices: invoiceReducer.invoices,
            loading: invoiceReducer.loading
        })
    );

    const {invoices, loading} = useSelector(InvoiceProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        //if (!invoices || invoices.length === 0) {
        if ((!invoices || invoices.length === 0)) {
            dispatch(onGetInvoices());
        }
    }, [dispatch, invoices, loading]);


  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setPurchase(null);
        } else {
            setModal(true);
        }
    };

    const handleEventClick = arg => {
        const event = arg;
        setPurchase({
            uid: event.uid,
            title: event.title,
            event_category_id: event.event_category_id,
            content: event.content,
            
        });

        




        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (event) => {
        setPurchase(event);
        setDeleteModal(true);
    };

    const handleDeletePurchase = () => {
        if (purchase && purchase.id) {
            dispatch(onDeletePurchase(purchase.uid));
            setDeleteModal(false);
        }
    };

    // On add
     const onClickNewEvent = () => {
        setIsEdit(false);
        setPurchase(null);
        
        toggle();
        //setModal(true)
    };






    // ✅ Gère l’ouverture conditionnelle du modal
  const toggleViewModal = (invoiceData = null) => {
    if (modal1) {
      // Fermeture propre
      setModal1(false);
      setSelectedInvoice(null);
    } else if (invoiceData) {
      // Ouvre le modal seulement si les données existent
      setSelectedInvoice(invoiceData);
      setModal1(true);
    }
  };


    


   

    const columns = useMemo(
        () => [
            {
                header: "ID",
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date",
                accessorKey: "created_at",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const dateStr = cellProps.row.original.created_at;
                    //return format(dateStr, "dd/MM/yyyy HH:mm", { locale: fr }); 
                    return format(dateStr, "dd/MM/yyyy", { locale: fr }); 
                },
            },
            {
                header: "Utilisateur",
                accessorKey: "account.uid",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Méthode paiement",
                accessorKey: "payment_method.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Total TTC",
                accessorKey: "total_incl_tax",
                enableColumnFilter: false,
                enableSorting: true,
            },

             {
                header: "État",
                accessorKey: "status",
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: 'Détails',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                    <Button
                        type="button"
                        color="primary"
                        className="btn-sm btn-rounded"
                        onClick={() => {
                            const orderData = cellProps.row.original; 
                            console.log("LOG: ", orderData);
                            toggleViewModal(orderData)
                        }}
                    >
                        Détails
                    </Button>);
                }
            },
            
           
          
          
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                           {/*
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleEventClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                             */}
                           


                        </ul>
                    );
                }
            },
            
        ],
         [toggleViewModal]
        //[]
    );

    return (
        <React.Fragment>

             <ShowInvoiceModal 
                isOpen={modal1} 
                toggle={toggleViewModal} 
                invoice={selectedInvoice}
            />

            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeletePurchase}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Listes des factures" breadcrumbItem="Factures" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    {/*<Link to="#!" onClick={onClickNewEvent} className="btn btn-primary me-1">Ajouter un événement</Link>*/}
                                                    {/*<Link to="#!" className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link>
                                                    <UncontrolledDropdown className="dropdown d-inline-block me-1">
                                                        <DropdownToggle type="menu" className="btn btn-success" id="dropdownMenuButton1">
                                                            <i className="mdi mdi-dots-vertical"></i></DropdownToggle>
                                                        <DropdownMenu>
                                                            <li><DropdownItem href="#">Action</DropdownItem></li>
                                                            <li><DropdownItem href="#">Another action</DropdownItem></li>
                                                            <li><DropdownItem href="#">Something else here</DropdownItem></li>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>*/}
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={invoices || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={false}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Search for ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                   
                </div>
            </div>
            <ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
/>


        </React.Fragment>
    );
}


export default Invoice;